import type { Context } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { escapeLikePattern } from "../likePattern";

export const ownConnectorGrants = (ctx: Context, email?: string) =>
  zql.oauthConnections
    .where("tenantId", ctx.tenantId)
    .where("connectedAppId", "IS NOT", null)
    .where(({ or, and, cmp, exists }) =>
      ctx.principal?.kind === "serviceAccount"
        ? cmp("id", "IN", [])
        : or(
            and(cmp("subjectKind", "user"), cmp("subjectId", ctx.userId)),
            ...(email
              ? [
                  and(
                    cmp("subjectKind", "email"),
                    cmp("subjectId", email.toLowerCase()),
                    exists("tenantMembers", (member) =>
                      member
                        .where("id", ctx.userId)
                        .where("email", "ILIKE", escapeLikePattern(email))
                    )
                  ),
                ]
              : [])
          )
    );
